import Vue from "vue";
import axios from "axios";
import store from "../store";
import router from "../router";
import { convertToBase64 } from "../utils/inforFormat";

const Requester = axios.create({
    baseURL: process.env.NODE_ENV === "production" ? window.location.origin : "http://192.168.1.20:81"
});

Requester.interceptors.response.use((response) => response, (err) => {
    const requiresAuth = (router.currentRoute.meta?.requiresAuth && router.currentRoute.meta.requiresAuth == true);

    if (err.response.status == 400) {
        if (typeof Vue.prototype.$throwAppMessage === 'function') {
            Vue.prototype.$throwAppMessage({ 
                message: err.response.data?.message ?? "Error del cliente",
                icon: "icofont-close-circled",
                type: 'error',
            });
        }
    }
    else if (err.response.status == 401) {
        store.commit("endSession", requiresAuth);
        if (typeof Vue.prototype.$throwAppMessage === 'function' && requiresAuth) {
            Vue.prototype.$throwAppMessage({ 
                message: err.response.data?.message ?? "Autenticacion requerida",
                icon: "icofont-warning",
                type: 'warn',
            });
        }
    } 
    else if (err.response.status == 403) {
        //if (requiresAuth) router.back();
        if (typeof Vue.prototype.$throwAppMessage === 'function') {
            Vue.prototype.$throwAppMessage({ 
                message: err.response.data?.message ?? "Acceso limitado",
                icon: "icofont-warning",
                type: 'warn',
            });
        }
    }
    else if (err.response.status == 404) {
        if (typeof Vue.prototype.$throwAppMessage === 'function') {
            Vue.prototype.$throwAppMessage({ 
                message: err.response.data?.message ?? "Recurso no encontrado",
                icon: "icofont-warning",
                type: 'warn',
            });
        }
    }
    else if (err.response.status >= 500) {
        if (typeof Vue.prototype.$throwAppMessage === 'function') {
            Vue.prototype.$throwAppMessage({ 
                message: err.response.data?.message ?? err.message,
                icon: "icofont-close-circled",
                type: 'error',
            });
        }
    }
    else if (requiresAuth) {
        if (typeof Vue.prototype.$throwAppMessage === 'function') {
            Vue.prototype.$throwAppMessage({ 
                message: err.response.data?.message ?? err.message,
                icon: "icofont-close-circled",
                type: 'error',
            });
        }
    }
    else {
        if (typeof Vue.prototype.$throwAppMessage === 'function') {
            Vue.prototype.$throwAppMessage({ 
                message: err.response.data?.message ?? err.message,
                icon: "icofont-close-circled",
                type: 'error',
            });
        }
    }
    return Promise.reject(err);
});

Requester.interceptors.request.use((request) => {
    if (request.headers.Authorization == "*") request.headers.Authorization = store.getters["getAuthorization"]();
    return request;
});

const axiosRequest = {
    Post: {
        newMember: async (data) => {
            let result = await Requester.post('api/creators/miembro', data, { headers: { Authorization: "*" } });
            return result
        },
        newStation: async (data) => {
            let result = await Requester.post('api/creators/escuela', data, { headers: { Authorization: "*" } });
            return result
        },
        newDepartment: async (data) => {
            let result = await Requester.post('api/creators/grado', data, { headers: { Authorization: "*" } });
            return result
        },
        newUserType: async (data) => {
            let result = await Requester.post('api/creators/user-type', data, { headers: { Authorization: "*" } });
            return result
        },
        newHighlight: async (data) => {
            let result = await Requester.post('api/creators/highlight', data, { headers: { Authorization: "*" } });
            return result
        },
        newSchedule: async (data) => {
            let result = await Requester.post('api/creators/schedule', data, { headers: { Authorization: "*" } });
            return result
        },
        newPractice: async (data) => {
            let result = await Requester.post('api/creators/practice', data, { headers: { Authorization: "*" } });
            return result
        },
        uploadFile: async (formData, pcb) => {
            let res = await Requester.post(`/api/files/upload`, formData, { headers: { Authorization: '*' }, onUploadProgress: pcb });
            return res;
        },
        login: async (credentials) => {
            let result = await Requester.post('api/authorize/login', credentials);
            return result
        }
    },
    Get: {
        tipoMiembros: async (page = null) => {
            let tipos = await Requester.get(`api/common/tipo-miembro${page > 0 ? '?page=' +page : ''}`, { headers: { Authorization: "*" } });
            return tipos;
        },
        Grados: async (page) => {
            let grados = await Requester.get(`api/common/grados${page > 0 ? '?page=' +page : ''}`, { headers: { Authorization: "*" } });
            return grados;
        },
        Escuelas: async (page = 0, shorten = false, schedule = false) => {
            let escuelas = await Requester.get(`api/common/escuelas${page > 0 ? '?page=' +page : ''}${shorten ? '?shorten=true' : ''}${schedule ? '?schedule=true' : ''}`, { headers: { Authorization: "*" } });
            return escuelas;
        },
        tipoEntrenamientos: async () => {
            let tipos = await Requester.get('api/common/tipo-entrenamiento');
            return tipos;
        },
        diasDeLaSemana: async () => {
            let dias = await Requester.get('api/common/dias-semana');
            return dias;
        },
        Permisos: async () => {
            let permisos = await Requester.get('api/getters/permisos', { headers: { Authorization: "*" } });
            return permisos;
        },
        Miembros: async (page, filters) => {
            let miembros = await Requester.get(`api/getters/miembros?page=${page}${filters ? `&filters=${convertToBase64(JSON.stringify(filters))}` : ''}`, { headers: { Authorization: "*" }} );
            return miembros;
        },
        NombreMiembros: async (id = null, nombre = null) => {
            let miembros = await Requester.get(`api/getters/miembros/nombres${id ? `?id=${id}` : ''}${nombre ? `?name=${nombre}` : ''}`, { headers: { Authorization: "*" } });
            return miembros;
        },
        Miembro: async (identity) => {
            let miembro = await Requester.get(`api/getters/miembro?id=${identity}`, { headers: { Authorization: "*" } });
            return miembro;
        },
        MiembroByCode: async (code) => {
            let miembro = await Requester.get(`api/common/miembro?member-code=${code}`);
            return miembro;
        },
        Files: async (identity) => {
            let files = await Requester.get(`api/files?id=${identity}`, { headers: { Authorization: "*" } });
            return files;
        },
        DownloadFile: async (identity, pcb) => {
            let files = await Requester.get(`api/files/download?id=${identity}`, { responseType: 'blob' , headers: { Authorization: "*" }, onDownloadProgress: pcb });
            return files;
        },
        validateAccess: async () => {
            let result = await Requester.get('api/authorize', { headers: { Authorization: "*" } });
            return result
        },
        validateIdentityExists: async (identity, email) => {
            let result = await Requester.get(`api/common/identification-existis?${identity ? `identity=${identity}` : ''}${email ? `&email=${email}` : ''}`);
            return result
        },
        Highlights: async (page) => {
            let highlights = await Requester.get(`api/getters/highlights${page > 0 ? '?page=' +page : ''}`, { headers: { Authorization: "*" } });
            return highlights;
        },
        Schedule: async (id, page, shorten = false) => {
            let schedule = await Requester.get(`api/getters/schedule?id=${id}${page ? '&page='+page : ''}${shorten ? '&shorten=true' : ''}`, { headers: { Authorization: "*" } });
            return schedule;
        },
        Practices: async (schoolid, page) => {
            let practices = await Requester.get(`api/getters/practice?${schoolid ? '&id='+schoolid : ''}${page ? '&page='+page : ''}`, { headers: { Authorization: "*" } });
            return practices;
        },
        openHighlights: async () => {
            let highlights = await Requester.get(`api/common/highlights`,);
            return highlights;
        },
        generateMemberForm: async (id) => {
            let form = await Requester.get(`/api/reporter/print/member?id=${id}`, { responseType: 'blob', headers: { Authorization: "*" } });
            return form;
        },
        generateMembersListForm: async (filters, includePhotos) => {
            let form = await Requester.get(`/api/reporter/print/members?includePhotos=${includePhotos}${filters ? `&filters=${convertToBase64(JSON.stringify(filters))}`: ''}`, { responseType: 'blob', headers: { Authorization: "*" } });
            return form;
        },
        LevelResume: async () => {
            let resume = await Requester.get(`api/getters/members-by-level`, { headers: { Authorization: "*" } });
            return resume;
        },
        MemberResume: async () => {
            let resume = await Requester.get(`api/getters/members-resume`, { headers: { Authorization: "*" } });
            return resume;
        }
    },
    Delete: {
        removeContact: async (data) => {
            let response = await Requester.delete('api/erase/remove-contact', { headers: { Authorization: '*' }, data });
            return response;
        },
        removeAcademicPrep: async (data) => {
            let response = await Requester.delete('api/erase/remove-academic', { headers: { Authorization: '*' }, data });
            return response;
        },
        removeUserType: async (id) => {
            let response = await Requester.delete(`api/erase/user-type?id=${id}`, { headers: { Authorization: '*' } });
            return response;
        },
        removeEscuela: async (id) => {
            let response = await Requester.delete(`api/erase/escuela?id=${id}`, { headers: { Authorization: '*' } });
            return response;
        },
        removeDepartment: async (id) => {
            let response = await Requester.delete(`api/erase/level?id=${id}`, { headers: { Authorization: '*' } });
            return response;
        },
        removeFile: async (data) => {
            let response = await Requester.delete(`api/files/status`, { headers: { Authorization: '*' }, data });
            return response;
        },
        removeHighlight: async (id) => {
            let response = await Requester.delete(`api/erase/highlight?id=${id}`, { headers: { Authorization: '*' } });
            return response;
        },
        removeSchedule: async (id) => {
            let response = await Requester.delete(`api/erase/schedule?id=${id}`, { headers: { Authorization: '*' } });
            return response;
        },
        removePractice: async (id) => {
            let response = await Requester.delete(`api/erase/practice?id=${id}`, { headers: { Authorization: '*' } });
            return response;
        },
        removeAtendance: async (id) => {
            let response = await Requester.delete(`api/erase/atendance?id=${id}`, { headers: { Authorization: '*' } });
            return response;
        },
    },
    Put: {
       
    },
    Patch: {
        UpdateMiembro: async (field, status = false) => {
            let response = await Requester.patch(`api/setters/miembro${ status ? '/status' : '' }`, field, { headers: { Authorization: "*" } });
            return response;
        },
        UpdateDepartment: async (field) => {
            let response = await Requester.patch('api/setters/level', field, { headers: { Authorization: "*" } });
            return response;
        },
        UpdateStacion: async (field) => {
            let response = await Requester.patch('api/setters/escuela', field, { headers: { Authorization: "*" } });
            return response;
        },
        UpdateUserType: async (field) => {
            let response = await Requester.patch('api/setters/user-type', field, { headers: { Authorization: "*" } });
            return response;
        },
        UpdateSchedule: async (field) => {
            let response = await Requester.patch('api/setters/schedule', field, { headers: { Authorization: "*" } });
            return response;
        },
        UpdatePractice: async (field) => {
            let response = await Requester.patch('api/setters/practice', field, { headers: { Authorization: "*" } });
            return response;
        },
        allowAccess: async (field) => {
            let response = await Requester.patch('api/setters/allow-access', field, { headers: { Authorization: "*" } });
            return response;
        },
        addPermission: async (data) => {
            let response = await Requester.patch('api/setters/add-permission', data, { headers: { Authorization: "*" } });
            return response;
        },
        removePermission: async (data) => {
            let response = await Requester.patch('api/setters/remove-permission', data, { headers: { Authorization: "*" } });
            return response;
        },
        addContact: async (data) => {
            let response = await Requester.patch('api/setters/add-contact', data, { headers: { Authorization: "*" } });
            return response;
        },
        addAcademicPrep: async (data) => {
            let response = await Requester.patch('api/setters/add-academic', data, { headers: { Authorization: "*" } });
            return response;
        },
        restoreUserType: async (id) => {
            let response = await Requester.patch(`api/setters/restore/user-type?id=${id}`, null, { headers: { Authorization: '*' } });
            return response;
        },
        restoreEscuela: async (id) => {
            let response = await Requester.patch(`api/setters/restore/escuela?id=${id}`, null, { headers: { Authorization: '*' } });
            return response;
        },
        restoreDepartment: async (id) => {
            let response = await Requester.patch(`api/setters/restore/level?id=${id}`, null, { headers: { Authorization: '*' } });
            return response;
        },
        restoreFile: async (data) => {
            let response = await Requester.patch(`api/files/status`, data, { headers: { Authorization: '*' } });
            return response;
        },
        setFilename: async (data) => {
            let response = await Requester.patch(`api/files`, data, { headers: { Authorization: '*' } });
            return response;
        },
        Highlight: async (data) => {
            let response = await Requester.patch('api/setters/highlight', data, { headers: { Authorization: "*" } });
            return response;
        },
        restoreHighlight: async (id) => {
            let response = await Requester.patch(`api/setters/restore/highlight?id=${id}`, null, { headers: { Authorization: '*' } });
            return response;
        },
        restoreSchedule: async (id) => {
            let response = await Requester.patch(`api/setters/restore/schedule?id=${id}`, null, { headers: { Authorization: '*' } });
            return response;
        },
        restorePractice: async (id) => {
            let response = await Requester.patch(`api/setters/restore/practice?id=${id}`, null, { headers: { Authorization: '*' } });
            return response;
        },
        restoreAtendance: async (id) => {
            let response = await Requester.patch(`api/setters/restore/atendance?id=${id}`, null, { headers: { Authorization: '*' } });
            return response;
        },
        appendAtendance: async (data) => {
            let response = await Requester.patch(`api/setters/append/atendance`, data, { headers: { Authorization: '*' } });
            return response;
        },
    },
    Instance: Requester
};

export default axiosRequest;